import { useAuth } from '../contexts/AuthContext';

const PermissionGuard = ({ permission, children, fallback = null }) => {
  const { hasPermission } = useAuth();

  if (hasPermission(permission)) {
    return children;
  }

  return fallback;
};

export default PermissionGuard; 